<template>
  <el-row type="flex" justify="center" >
    <el-col
        class="location-form-container"
        :span="22"
    >
      <el-row>
        <el-row v-if="selectedLocation">
          <h4>Редактирование локации {{selectedLocation.name}}</h4>
        </el-row>

        <el-row v-else>
          <h4>Добавление локации</h4>
        </el-row>

        <el-row class="form-fields">
          <el-row>
            <el-col :span="6">Название</el-col>
            <el-col :span="18">
              <el-input
                  type="text"
                  placeholder="Введите название"
                  v-model="selectedLocation.name"
              ></el-input>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">Описание</el-col>
            <el-col :span="18">
              <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="Введите описание"
                  v-model="selectedLocation.description">
              </el-input>
            </el-col>
          </el-row>
        </el-row>


      </el-row>
      <el-row class="command-buttons">
        <el-button
            plain
            @click="cancel"
        >
          Отмена
        </el-button>

        <el-button
            type="primary"
            @click="save"
        >
          Сохранить
        </el-button>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "location-form",
  props: {
    selectedLocation :{},
  },
  data() {
    return {}
  },
  mounted() {

  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    save() {
      this.$emit('save')
    }
  }
}
</script>

<style lang="scss" scoped>

  .location-form-container {
    h4 {
      text-align: center;
    }

    .form-fields {
      > .el-row {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        > .el-col {
          &:first-child {
            padding-right: 10px;
            text-align: right;
          }
        }
      }
    }

    .command-buttons {
      text-align: center;
      margin-bottom: 25px;
    }
  }

</style>